import {jQuery as $, lodash as _} from 'lib/shim';



const TOGGLE_DATA_MARKER = 'data-toggle',
	TOGGLE_DATA_MARKER_CLOSE = 'data-close';



/*
 * todo: This is the rewrite of Stephan Bruny's global applyToggle() function, which was globally
 * called in app.js (which is a terrible way to do such things). The only place I found this was used
 * was in the global page header, so I moved the code to this snippet and imported and used it explicitly there.
 *
 * This is still not a beautiful solution, but should work for the time being
 */
export function prepareToggles($target){
	let $targets = $target.find('['+TOGGLE_DATA_MARKER+']');

	$targets.on('click', function(e){
		e.preventDefault();

		let $sameTargetToggles = $targets.filter('['+TOGGLE_DATA_MARKER+'="'+$(this).attr(TOGGLE_DATA_MARKER)+'"]'),
			$toggleTarget = $($(this).attr(TOGGLE_DATA_MARKER)),
			$closingChildren = $toggleTarget.find('['+TOGGLE_DATA_MARKER_CLOSE+']');

		if( !$(this).hasClass('active') ){
			$(this).add($sameTargetToggles).addClass('active');
			$toggleTarget.removeClass('hidden');

			$closingChildren.each(function(){
				$(this).off('click.toggle').one('click.toggle', (e) => {
					e.preventDefault();

					$(this).add($sameTargetToggles).removeClass('active');
					$toggleTarget.addClass('hidden');
				});
			});
		} else {
			$(this).add($sameTargetToggles).removeClass('active');
			$toggleTarget.addClass('hidden');
		}
	});
}
